export const ComponentNames = Object.freeze({
  Analytics: 'Analytics',
  Flows: 'Flows',
  Dashboard: 'Dashboard',
  NLP: 'NLP',
  Professionals: 'Professionals',
  ServiceUsers: 'Service users',
  Support: 'Conversations',
  Broadcasts: 'Broadcasts',
  Widget: 'Widget',
  BotSettings: 'Bot Settings',
})
